// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__Qk7Yk","tab":"Tabs_tab__1OJuP","tabActive":"Tabs_tabActive__1TXzO"};